var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isMobileOnly } from 'react-device-detect';
export var isSsr = typeof window === 'undefined';
export var getHost = function () {
    if (isSsr)
        return '';
    if (process.env.NODE_ENV === 'production' && !process.env.DOMAIN_NAME) {
        return "https://".concat(window.location.hostname);
    }
    return window.location.origin;
};
export var getChannelID = function () { return (isMobileOnly ? 2 : 1); };
export var generateXB3TraceID = function () {
    return Math.random().toString(16).substring(2) +
        new Date().getTime().toString(16).substring(0, 15);
};
export var transformToTrialsObj = function (_a) {
    var _b;
    var data = _a.data;
    var trials = {};
    (_b = data === null || data === void 0 ? void 0 : data.features) === null || _b === void 0 ? void 0 : _b.forEach(function (feature) {
        trials[feature] = true;
    });
    return trials;
};
export var filterOutPII = function (_a) {
    var data = _a.data;
    var firstName = data.firstName, lastName = data.lastName, phoneNumber = data.phoneNumber, email = data.email, userAddress = data.userAddress, customer = data.customer, needed = __rest(data, ["firstName", "lastName", "phoneNumber", "email", "userAddress", "customer"]);
    var customerPhone = customer.phoneNumber, accountName = customer.accountName, neededFromCustomer = __rest(customer, ["phoneNumber", "accountName"]);
    return __assign(__assign({}, needed), { customer: __assign({}, neededFromCustomer) });
};
export var getConfigurationValue = function (value) { var _a; return (_a = window.__EXPERIENCE_PROPS__) === null || _a === void 0 ? void 0 : _a.expConfiguration[value]; };
export var mapResponseToCustomerModel = function (response) {
    return response;
};
export var mapResponseToPerksInfoModel = function (response) {
    return response;
};
export var mapResponseToPerksRedeemModel = function (response) {
    return response;
};
export var mapResponseToPerksAvailableModel = function (response) {
    return response;
};
export var mapResponseToChallengesInfoModel = function (response) {
    return response;
};
export var mapResponseToChallengeAcceptModel = function (response) {
    return response;
};
export var mapResponseToChoosePerksActivateModel = function (response, type) {
    return __assign(__assign({}, response), { type: type });
};
